// CallbackPage.js
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { domain } from "../../services/constants";

export default function CallbackPage() {
    const [params] = useSearchParams();

    useEffect(() => {
        const code = params.get("code");
        const codeVerifier = sessionStorage.getItem("canvaId");

        fetch(`${domain}/account/canva/exchange_code/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ code, code_verifier: codeVerifier }),
        })
            .then((res) => res.json())
            .then((data) => {
                console.log("Access token:", data.access_token);
            });
    }, []);

    return <p>Processing...</p>;
}
